import {
  MdSpaceDashboard,
  MdGroups,
  MdInsights,
  MdEventNote,
  MdCalendarMonth,
  MdPeople,
  MdMedicalServices,
  MdDescription,
  MdKingBed,
  MdPersonAddAlt1,
  MdHotel,
  MdMonitorHeart,
  MdReceiptLong,
  MdPointOfSale,
  MdMedication,
  MdScience,
  MdBadge,
  MdSettings,
  MdSms,
  MdAutoAwesome,
  MdApps,
} from 'react-icons/md';

/** Map a nav route to a meaningful icon (falls back to a generic tile). */
const ICON_BY_PATH = {
  '/manager/dashboard': MdSpaceDashboard,
  '/manager/admin': MdGroups,
  '/hms/analysis': MdInsights,
  '/reception/queue': MdEventNote,
  '/hms/appointments': MdCalendarMonth,
  '/reception/patients': MdPeople,
  '/doctor/queue': MdMedicalServices,
  '/hms/emr': MdDescription,
  '/ipd/list': MdKingBed,
  '/ipd/admit': MdPersonAddAlt1,
  '/ipd/beds': MdHotel,
  '/nurse/station': MdMonitorHeart,
  '/billing/receipts': MdReceiptLong,
  '/billing/op': MdPointOfSale,
  '/pharmacy/desk': MdMedication,
  '/lab/orders': MdScience,
  '/hr/dashboard': MdBadge,
  '/hr/staff': MdBadge,
  '/staff/directory': MdGroups,
  '/hms/settings': MdSettings,
  '/hms/ai': MdAutoAwesome,
  '/hms/sms': MdSms,
};

export function navIcon(path) {
  return ICON_BY_PATH[path] || MdApps;
}
